import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useGetAuthUrlForSlack = () => {
    const { t } = useTranslation('newNotifications');
    const toastHandler = useContainer(ToastStateHandler);
    const userApi = useContainer(UserApi);
    const getRedirectionUrl = () => {
        const { exec, abort } = userApi.activateSlackIntegration({
            onSuccess: res => {
                window.location.href = decodeURIComponent(res.body.redirectUrl);
            },
            onError: () => {
                toastHandler.push('error', t('slackIntegration.slackIntegrationTitle'), t('slackIntegration.slackIntegrationError'));
            },
        });
        exec();
        return abort;
    };
    return { getRedirectionUrl };
};

export default useGetAuthUrlForSlack;
